<template>
  <div :class="$store.state.IsLittleScreen ? 'little-login-modal' : 'login-modal'">

    <div class="mask flex align-center justify-center" v-if="showLogin">
      <div class="modal flex flex-direction align-center" @click.stop="">
        <i class="el-icon-close close-icon" @click="showLogin = false"></i>
        <div class="flex flex-direction align-center">
          <div v-if="loginType === 'weChat'" class="flex align-center" style="margin-top: 90px">
            <img style="width: 30px;height: 30px;" src="../assets/gfMoney/login-wechat.png">
            <div class="login-title">微信扫描登录</div>
          </div>
          <div id="wxbox" class="code-box" v-show="loginType === 'weChat'"></div>
        </div>
        <div v-if="loginType === 'phone'" class="flex flex-direction align-center">
          <img style="width: 131px;height: 47px;margin-top: 29px" src="../assets/gfMoney/logo-login.png">
          <el-form ref="formTel" :rules="formTelRules" :model="formTel" style="margin-top: 29px;" :show-message="false">
            <el-form-item class="login-tab-conItem" prop="phone">
              <el-input class="login-tab-input" v-model="formTel.phone" :maxlength="11" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item class="login-tab-conItem login-tab-conItemCode" prop="sms">
              <el-input class="login-tab-input" v-model="formTel.sms" placeholder="验证码"></el-input>
              <span v-if="!this.timerObj.telTime.num" @click="telCodeFun('formTel')">获取验证码</span>
              <span v-else style="color: #b1b0b0">{{ this.timerObj.telTime.num }}s</span>
            </el-form-item>

            <el-form-item class="login-tab-conItem login-tab-conItemCode" prop="inviteCode">
              <el-input class="login-tab-input" v-model="inviteCode" placeholder="填写邀请码（非必填）"></el-input>
              <span style="color: #b1b0b0">邀请码</span>
            </el-form-item>
          </el-form>

          <div class="login-btn" @click="submitForm('login')">登录</div>
        </div>

        <div v-if="loginType === 'email'" class="flex flex-direction align-center">
          <img style="width: 131px;height: 47px;margin-top: 29px" src="../assets/gfMoney/logo-login.png">
          <el-form v-if="!isRegister && !isChangePwd" ref="formEmail" :rules="formEmailRules" :model="formEmail" :show-message="false">
            <el-form-item class="login-tab-conItem " prop="email">
              <el-input class="login-tab-input" v-model="formEmail.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>

            <el-form-item class="login-tab-conItem login-tab-conItemCode" prop="password">
              <el-input class="login-tab-input" v-model="formEmail.password" placeholder="请输入密码" type="password"></el-input>
              <span @click="isChangePwd = true">忘记密码</span>
            </el-form-item>
          </el-form>
          <!-- 邮箱注册 -->
          <el-form v-if="isRegister || isChangePwd" ref="formEmailReg" :model="formEmailReg" :rules="formEmailRegRules" :show-message="false">
            <el-form-item class="login-tab-conItem" prop="email">
              <el-input class="login-tab-input" v-model="formEmailReg.email" placeholder="请输入邮箱"></el-input>
            </el-form-item>

            <el-form-item class="login-tab-conItem" prop="newPwd">
              <el-input type="password" class="login-tab-input" v-model="formEmailReg.newPwd" placeholder="密码"></el-input>
            </el-form-item>

            <el-form-item class="login-tab-conItem" prop="oldPwd">
              <el-input type="password" class="login-tab-input" v-model="formEmailReg.oldPwd" placeholder="确认密码"></el-input>
            </el-form-item>

            <el-form-item class="login-tab-conItem login-tab-conItemCode" prop="randomCode">
              <el-input class="login-tab-input" v-model="formEmailReg.randomCode" placeholder="验证码"></el-input>

              <span v-if="!this.timerObj.emailTimer.num" @click="emailCodeFun('formEmailReg')">获取验证码</span>
              <span v-else style="color: #b1b0b0">{{ this.timerObj.emailTimer.num }}s</span>
            </el-form-item>

            <el-form-item class="login-tab-conItem login-tab-conItemCode" prop="inviteCode">
              <el-input class="login-tab-input" v-model="inviteCode" placeholder="填写邀请码（非必填）"></el-input>
              <span style="color: #b1b0b0">邀请码</span>
            </el-form-item>
          </el-form>

          <div class="login-btn" v-if="!isRegister && !isChangePwd" @click="submitForm('login')">登录</div>
          <div class="login-btn" v-if="isRegister" @click="submitForm('register')">注册</div>
          <div class="login-btn" v-if="isChangePwd" @click="submitForm('pwd')">提交</div>

          <div class="register">
            <!-- 如果是注册或者修改密码 -->
            <span v-if="isRegister || isChangePwd" @click="backlogin">返回登录</span>
            <span v-else @click="isRegister = true">注册</span>
          </div>
        </div>

        <div class="flex align-center justify-center" style="margin-top: 20px">
          <div class="s-line"></div>
          <div class="s-text">其它登录方式</div>
          <div class="s-line"></div>
        </div>
        <div class="flex align-center justify-center" style="margin-top: 45px;cursor: pointer">
          <div class="flex align-center" v-if="loginType !== 'weChat' && !$store.state.IsLittleScreen" @click="showWechat()">
            <img style="width: 30px;height: 30px;" src="../assets/gfMoney/login-wechat.png">
            <div class="login-type-text">微信登录</div>
          </div>
          <div class="flex align-center" v-if="loginType !== 'phone'" style="margin-left: 20px" @click="loginType = 'phone'">
            <img style="width: 30px;height: 30px;" src="../assets/gfMoney/login-phone.png">
            <div class="login-type-text">手机号登录</div>
          </div>
          <div class="flex align-center" v-if="!$store.state.IsLittleScreen" style="margin-left: 20px" @click="otherLogin('QQ')">
            <img style="width: 30px;height: 30px;" src="../assets/gfMoney/login-qq.png">
            <div class="login-type-text">QQ登录</div>
          </div>
          <div class="flex align-center" v-if="loginType !== 'email'" style="margin-left: 20px" @click="loginType = 'email'">
            <img style="width: 30px;height: 30px;" src="../assets/gfMoney/login-email.png">
            <div class="login-type-text">邮箱登录</div>
          </div>
        </div>

        <div class="agree-box flex align-center justify-center">
          <el-checkbox label v-model="isChecked" style="margin-right: 10px;"></el-checkbox>
          <div style="cursor: pointer" @click="dialogTableVisible = true">我已阅读并同意<span class="confirm-info__info">《用户服务条款》</span></div>
        </div>
      </div>
    </div>
    <el-dialog width="1000" :append-to-body="true" v-if="!$store.state.IsLittleScreen" :visible.sync="dialogTableVisible" title="请您仔细阅读以下内容" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="protocol-home-1">
        <el-main class="protocolPrivacy-1">
          <m-userPro></m-userPro>
        </el-main>
      </div>
      <div class="closeButton-1 flex align-center justify-center">
        <el-button type="primary" @click="agreeProtocol">我已阅读并同意以上协议 </el-button>
      </div>
    </el-dialog>

    <el-dialog width="80%" :append-to-body="true" v-if="$store.state.IsLittleScreen" :visible.sync="dialogTableVisible" title="请您仔细阅读以下内容" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="protocol-home">
        <el-main class="protocolPrivacy">
          <m-userPro></m-userPro>
        </el-main>
      </div>
      <div class="closeButton flex align-center justify-center">
        <el-button type="primary" size="mini" @click="agreeProtocol">我已阅读并同意以上协议 </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { myAccountApi, checkInviteCode } from "@/api/user";
import {
  telCodeApi,
  emailCodeApi,
  emailLoginApi,
  emailPwdApi,
  telLoginApi,
  otherLoginApi
} from "@/api/login";
import commonMixin from "@/mixins/commonMixin";
const timeMax = 120;
export default {
  mixins: [commonMixin],
  data () {
    var checkCode = (rule, value, callback) => {
      if (this.inviteCode) {
        let reg = /^\d{8}$/
        if (this.inviteCode.match(reg)) {
          checkInviteCode({ inviteCode: this.inviteCode }).then(res => {
            if (res.code == 200 && res.message == 'ok') {
              callback()
            } else {
              callback(new Error('活动邀请码错误，无邀请码可不填'));
            }
          })
            ;
        } else {
          callback(new Error('活动邀请码错误，无邀请码可不填'));
        }
      } else {
        callback();
      }
    };
    return {
      loginType: 'phone',
      isRegister: false,
      isChangePwd: false,
      showLogin: false,
      inviteCode: '',
      timerObj: {
        /* 手机号登录倒计时 */
        telTime: {
          loading: false,
          obj: null,
          num: 0,
        },
        /* 邮箱发送倒计时 */
        emailTimer: {
          loading: false,
          obj: null,
          num: 0,
        },
      },
      //对话框
      ReadComplete: true,
      dialogTableVisible: false,
      PrivacyPolicyClick: false,
      UserAgreementclick: true,
      actveTab: 'UserAgreement',
      /* tabBar */
      tabItem: {
        name: "手机登录",
        formName: "formTel",
        id: 0,
      },
      tabList: [
        {
          name: "手机登录",
          formName: "formTel",
          id: 0,
        },
        {
          name: "邮箱登录",
          formName: "formEmail",
          id: 1,
        },
      ],
      /* 注册类型 */
      actionType: {
        /* 是否为忘记密码 */
        isChangePwd: false,
        /* 是否为注册 */
        isRegister: false,
        /* 注册类型id */
        id: 1,
      },
      /* 表单 */
      formTel: {
        phone: "",
        sms: "",
      },
      formTelRules: {
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^[1-9][0-9]{10}$/,
            message: "请正确输入手机号",
            trigger: "blur",
          },
        ],
        sms: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        inviteCode: [
          { validator: checkCode, trigger: 'blur' }
        ],
      },
      formEmail: {
        email: "",
        randomCode: "",
        password: "",
      },
      formEmailRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/,
            message: "请正确输入邮箱",
            trigger: "blur",
          },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      formEmailReg: {
        email: "",
        /* 只要发验证码就是0 */
        type: 0,
        newPwd: "",
        oldPwd: "",
        password: "",
        randomCode: "",
      },
      formEmailRegRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern:
              /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/,
            message: "请正确输入邮箱",
            trigger: "blur",
          },
        ],
        newPwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern:
              /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
            message: "密码必须是由8-20位字母+数字组合",
            trigger: "blur",
          }
        ],
        oldPwd: [
          { required: true, message: "请确认密码", trigger: "blur" },
          {
            pattern:
              /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/,
            message: "密码必须是由8-20位字母+数字组合",
            trigger: "blur",
          }
        ],
        randomCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
        inviteCode: [
          { validator: checkCode, trigger: 'blur' }
        ],
      },
      isChecked: false,
      bannerList: [],
    };
  },
  created () {
    let inviteCode = localStorage.getItem("inviteCode")
    if (inviteCode) {
      this.inviteCode = inviteCode
    }
  },
  methods: {
    ...mapMutations({
      SET_USER_INFO: 'SET_USER_INFO'
    }),
    backlogin () {
      this.isRegister = false
      this.isChangePwd = false
    },
    showModal () {
      this.showLogin = true
      let inviteCode = localStorage.getItem("inviteCode")
      if (inviteCode) {
        this.inviteCode = inviteCode
      }
      this.setWeChatCode()
    },
    setWeChatCode () {
      otherLoginApi('WECHAT_OPEN', { bind: 0, marker: 'gfMoney' }).then(res => {
        if (res.code == 200) {
          let path = res.data
          let arr = path.split('=')
          let state = arr[arr.length - 1]
          this.$nextTick(() => {
            new WxLogin({
              self_redirect: false,
              id: "wxbox",
              appid: "wx497852a673842006",
              scope: "snsapi_login",
              redirect_uri: "https%3A%2F%2Fwww.cgsomo.com%2Fapi%2Fcgsj_app%2Fcallback%2FWECHAT_OPEN%3Fmarker%3D0%2F%2F%2FgfMoney",
              state: state,
              style: "black",
              href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDE4MHB4O30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5OiBub25lO30KLmltcG93ZXJCb3ggLmluZm8ge2Rpc3BsYXk6IG5vbmU7fQouc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9Ci5pbXBvd2VyQm94IC5zdGF0dXMge2Rpc3BsYXk6IG5vbmU7fQ=="
            });
          })
        }
      });
    },
    changeTab (item, flag = true) {
      if (item.id == this.tabItem.id && flag) {
        return false;
      }

      /* 重置表单 */
      this.resetForm("formTel");
      this.resetForm("formEmail");
      this.resetForm("formEmailReg");

      this.isChecked = false;

      this.actionType = Object.assign({}, this.actionType, {
        isChangePwd: false,
        isRegister: false,
        id: item.id,
      });

      this.tabItem = item;
    },

    /* 注册 */
    registerFun () {
      this.isChecked = false;
      this.actionType = {
        isChangePwd: false,
        isRegister: true,
        id: this.tabItem.id,
      };
      this.stopEmailTime();
    },
    /* 邮箱忘记密码 */
    forgetPwd () {
      this.isChecked = true;
      this.actionType = {
        isChangePwd: true,
        isRegister: false,
        id: this.tabItem.id,
      };
      this.stopEmailTime();
    },
    // 对话框
    agreeProtocol () {
      if (this.dialogTableVisible) {
        this.dialogTableVisible = false;
        this.isChecked = true;
      } else {
        this.dialogTableVisible = false;
      }
    },
    handleClick (tab, event) {

      if (tab.name == "PrivacyPolicy") {
        this.PrivacyPolicyClick = true;
      }

      if (this.PrivacyPolicyClick == true) {
        this.ReadComplete = false;
      } else {
        this.ReadComplete = true;
      }


    },
    /* 返回登录 */
    goBackLogin () {
      this.changeTab(this.tabList[1], false);
    },
    submitForm (type) {
      let formName = this.loginType === 'phone' ? 'formTel' : 'formEmail';

      let fromData = {};
      if (this.inviteCode) {
        fromData.inviteCode = this.inviteCode
      }
      let successText = '';
      let Api = null;

      if (type == "login") {
        /* 登录 */

        if (this.loginType === 'phone') {
          /* 手机号登录 */
          Api = telLoginApi;
          fromData.templateType = 101;
        } else if (this.loginType === 'email') {
          /* 邮箱登录 */
          Api = emailLoginApi;
          fromData.emailType = 201;
          fromData.type = 1;
        }
        if (!this.isChecked) {
          this.$message.error("请阅读并同意相关协议");
          return false;
        }
      } else if (type == "register") {
        successText = '注册成功';
        /* 注册,只有邮箱注册 */
        formName = "formEmailReg"
        /* 邮箱注册 */
        if (formName === "formEmailReg") {
          /* 判断两次密码是否一置 */
          let { newPwd, oldPwd } = this[formName];
          newPwd = newPwd.replace(/\s/g, "");
          oldPwd = oldPwd.replace(/\s/g, "");

          if (newPwd !== oldPwd) {
            this.$message.error("两次密码不一致");
            return false;
          } else {
            fromData.password = newPwd;
          }

          if (!this.isChecked) {
            this.$message.error("请阅读并同意相关协议");
            return false;
          }

          Api = emailLoginApi;
          fromData.emailType = 200;
          fromData.type = 0;
        }
      } else if (type == "pwd") {
        successText = '修改密码成功';
        /* 修改密码，只有邮箱有 */
        formName = "formEmailReg"
        /* 邮箱修改密码 */
        if (formName === "formEmailReg") {
          /* 判断两次密码是否一置 */
          let { newPwd, oldPwd } = this[formName];
          newPwd = newPwd.replace(/\s/g, "");
          oldPwd = oldPwd.replace(/\s/g, "");

          if (newPwd !== oldPwd) {
            this.$message.error("两次密码不一致");
            return false;
          } else {
            fromData.password = newPwd;
          }
          Api = emailPwdApi;
          fromData.emailType = 202;
          fromData.type = 0;
        }
      }

      let params = Object.assign({}, this[formName], fromData);

      this.$refs[formName].validate((valid, error) => {
        if (valid) {
          Api(params).then((res) => {
            if (res.code == 200) {
              if (successText) {
                this.$message.success(successText);
              }
              this.SET_USER_INFO({ token: res.data });
              myAccountApi().then((k) => {
                this.SET_USER_INFO(k.data);
                this.SET_USER_INFO({ token: res.data });
              })
              this.resetForm(formName);
              if (type == "login") {
                this.showLogin = false
                this.$emit("loginSuccess")
              } else {
                this.isRegister = false
                this.loginType = 'email'
              }
            }
          });
        } else {
          try {
            let keys = Object.keys(error);
            if (keys.length) {
              let key = keys[0];
              this.$message.error(error[key][0].message);
            }
          } catch (err) {
            this.$message.error("表单效验失败");
          }

          // console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].resetFields();
      }
    },
    /* 短信倒计时 */
    timerTelClick (callback) {
      this.stopTelTime();
      this.timerObj.telTime.num = timeMax;

      const TelTickFun = () => {
        --this.timerObj.telTime.num;

        if (this.timerObj.telTime.num <= 0) {
          this.timerObj.telTime.num = 0;
          clearInterval(this.timerObj.telTime.obj);
        }
      }

      TelTickFun();

      this.timerObj.telTime.obj = setInterval(TelTickFun, 1000);
    },
    /* 手机号发送验证码 */
    telCodeFun (formName) {
      this.$refs[formName].validateField("phone", (errorMessage) => {
        if (!errorMessage) {
          if (this.timerObj.telTime.loading) {
            return false;
          }

          this.timerObj.telTime.loading = true;

          telCodeApi({
            phone: this[formName].phone,
            templateType: 101,
          }).then((res) => {
            const { code, message } = res;
            if (code == 200) {
              this.timerTelClick();
            } else {
              this.$message.error(message);
            }
            this.timerObj.telTime.loading = false;
          }).catch(err => {
            this.timerObj.telTime.loading = false;
          });
        } else {
          this.$message.error(errorMessage);
        }
      });
    },
    /* 邮箱倒计时 */
    timerEmailClick () {
      this.stopEmailTime();
      this.timerObj.emailTimer.num = timeMax;

      const emailTickFun = () => {
        --this.timerObj.emailTimer.num;

        if (this.timerObj.emailTimer.num <= 0) {
          this.timerObj.emailTimer.num = 0;
          clearInterval(this.timerObj.emailTimer.obj);
        }
      }

      emailTickFun();

      this.timerObj.emailTimer.obj = setInterval(emailTickFun, 1000);
    },
    /* 邮箱发送验证码：邮箱注册、邮箱修改密码 */
    emailCodeFun (formName) {
      this.$refs[formName].validateField("email", (errorMessage) => {
        if (!errorMessage) {

          let params = {
            email: this[formName].email,
          };

          if (this.isChangePwd) {
            params.emailType = 202;
          }

          if (this.isRegister) {
            params.emailType = 200;
          }

          if (this.timerObj.emailTimer.loading) {
            return false;
          }

          this.timerObj.emailTimer.loading = true;

          emailCodeApi(params).then((res) => {
            const { code, message } = res;
            if (code == 200) {
              this.timerEmailClick();
            } else {
              this.$message.error(message);
            }
            this.timerObj.emailTimer.loading = false;
          }).catch(err => {
            this.timerObj.emailTimer.loading = false;
          });
        } else {
          this.$message.error(errorMessage);
        }
      });
    },
    stopTelTime () {
      clearInterval(this.timerObj.telTime.obj);
      this.timerObj.telTime.num = 0;
    },
    stopEmailTime () {
      clearInterval(this.timerObj.emailTimer.obj);
      this.timerObj.emailTimer.num = 0;
    },
    showWechat () {
      if (!this.isChecked) {
        this.$message.error("请阅读并同意相关协议");
        return false;
      }
      this.loginType = 'weChat'
    },
    otherLogin (type) {
      if (!this.isChecked) {
        this.$message.error("请阅读并同意相关协议");
        return false;
      }
      otherLoginApi(type, { bind: 0, marker: 'gfMoney' }).then(res => {
        if (res.code == 200) {
          window.location.href = res.data;
        }
      });
    },
    getBanner () {
      /* 1 首页 2 搜索页 3 活动页 */
      getBannerApi({ position: 2 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
//隐私政策页面
.protocolPrivacy-1 {
  width: 920px;
  height: 550px;
}

.protocol-home-1 {
  width: 950px;
  height: 560px;
}

.closeButton-1 {
  position: relative;
  // bottom: 15px;
  top: 15px;
  margin: auto;
}
.closeButton {
  position: relative;
  top: 15px;
}
//隐私政策页面
.protocolPrivacy {
  width: 100%;
  height: 60vh;
}
.protocol-home {
  width: 100%;
  height: 60vh;
}
.little-login-modal {
  .confirm-info__info {
    text-decoration: underline;
    color: rgb(255, 0, 0);
    margin: 0 6px;
  }

  .code-box {
    width: 300px;
    height: 400px;
    margin-top: 40px;
    background-color: #eeeeee;
  }
  .s-line {
    width: 120px;
    height: 1px;
    background: #eeeeee;
  }
  .s-text {
    font-size: 10px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin: 0 10px;
  }
  .login-title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #666666;
    margin-left: 12px;
  }
  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 36px;
    color: #999999;
    cursor: pointer;
  }
  .agree-box {
    width: 100%;
    height: 60px;
    background-color: #eeeeee;
    position: absolute;
    bottom: 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 100;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: rgba(#000000, 0.4);
    .modal {
      width: 350px;
      background: #ffffff;
      position: relative;
      padding-bottom: 80px;
    }
  }
  .register {
    padding: 10px 10px 0;
    text-align: right;
    width: 308px;
    font-size: 14px;
    color: #b1b0b0;

    span {
      cursor: pointer;
    }
  }
  .login-btn {
    width: 295px;
    height: 40px;
    background: #f04142;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
  }
  .el-input {
    width: 206px;
  }
  .el-form {
    width: 296px;
  }
  .login-tab-conItem {
    margin-top: 16px;
    border-radius: 0px;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    height: 40px;
    line-height: 22px;
    background: #f8f8f8;
    .el-form-item__content {
      display: flex;
      line-height: inherit;
      margin: 0;
      padding: 0;
    }

    .login-tab-input {
      background: #f8f8f8;
      .el-input__inner {
        border: none;
        font-size: 14px;
        height: 100%;
        line-height: 100%;
        box-shadow: none;
        outline: none;
        background: #f8f8f8;
      }
    }

    &.login-tab-conItemCode {
      span {
        color: #222;
        cursor: pointer;
        flex-shrink: 0;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
      }
    }
  }
  .login-type-text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 11px;
  }
}
.login-modal {
  .confirm-info__info {
    text-decoration: underline;
    color: rgb(255, 0, 0);
    margin: 0 6px;
  }

  .code-box {
    width: 300px;
    height: 230px;
    margin-top: 20px;
  }
  .s-line {
    width: 120px;
    height: 1px;
    background: #eeeeee;
  }
  .s-text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin: 0 20px;
  }
  .login-title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #666666;
    margin-left: 12px;
  }
  .close-icon {
    position: absolute;
    top: 16px;
    right: 16px;
    font-size: 36px;
    color: #999999;
    cursor: pointer;
  }
  .agree-box {
    width: 100%;
    height: 60px;
    background-color: #eeeeee;
    position: absolute;
    bottom: 0;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 100;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background-color: rgba(#000000, 0.4);
    .modal {
      width: 560px;
      background: #ffffff;
      position: relative;
      padding-bottom: 80px;
    }
  }
  .register {
    padding: 10px 10px 0;
    text-align: right;
    width: 423px;
    font-size: 14px;
    color: #b1b0b0;

    span {
      cursor: pointer;
    }
  }
  .login-btn {
    width: 423px;
    height: 60px;
    background: #f04142;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }
  .el-input {
    width: 330px;
  }
  .el-form {
    width: 423px;
  }

  .login-tab-conItem {
    margin-top: 16px;
    border-radius: 0px;
    box-sizing: border-box;
    display: flex;
    height: 60px;
    line-height: 22px;
    padding: 15px 12px;
    width: 100%;
    background: #f8f8f8;

    .el-form-item__content {
      display: flex;
      width: 100%;
      line-height: inherit;
      margin: 0;
      padding: 0;
    }

    .login-tab-input {
      background: #f8f8f8;
      .el-input__inner {
        border: none;
        font-size: 14px;
        height: 100%;
        line-height: 100%;
        width: 100%;
        box-shadow: none;
        outline: none;
        background: #f8f8f8;
      }
    }

    &.login-tab-conItemCode {
      span {
        color: #222;
        cursor: pointer;
        flex-shrink: 0;
        font-size: 14px;
        height: 22px;
        line-height: 22px;
      }
    }
  }
  .login-type-text {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 11px;
  }
}
</style>
